// @generated by protoc-gen-es v2.16.0 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file trails_lat/proto/data.proto (package lat.trails, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file trails_lat/proto/data.proto.
 */
export const file_trails_lat_proto_data = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message lat.trails.AcceptInviteRequest.
 * Use `create(AcceptInviteRequestSchema)` to create a new message.
 */
export const AcceptInviteRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 0);

/**
 * Describes the message lat.trails.AcceptInviteResponse.
 * Use `create(AcceptInviteResponseSchema)` to create a new message.
 */
export const AcceptInviteResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 1);

/**
 * Describes the message lat.trails.CreateCollectionRequest.
 * Use `create(CreateCollectionRequestSchema)` to create a new message.
 */
export const CreateCollectionRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 2);

/**
 * Describes the message lat.trails.CreateCollectionResponse.
 * Use `create(CreateCollectionResponseSchema)` to create a new message.
 */
export const CreateCollectionResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 3);

/**
 * Describes the message lat.trails.CreateInviteRequest.
 * Use `create(CreateInviteRequestSchema)` to create a new message.
 */
export const CreateInviteRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 4);

/**
 * Describes the message lat.trails.CreateInviteResponse.
 * Use `create(CreateInviteResponseSchema)` to create a new message.
 */
export const CreateInviteResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 5);

/**
 * Describes the message lat.trails.DeleteAccountRequest.
 * Use `create(DeleteAccountRequestSchema)` to create a new message.
 */
export const DeleteAccountRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 6);

/**
 * Describes the message lat.trails.DeleteAccountResponse.
 * Use `create(DeleteAccountResponseSchema)` to create a new message.
 */
export const DeleteAccountResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 7);

/**
 * Describes the message lat.trails.DeleteCollectionRequest.
 * Use `create(DeleteCollectionRequestSchema)` to create a new message.
 */
export const DeleteCollectionRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 8);

/**
 * Describes the message lat.trails.DeleteCollectionResponse.
 * Use `create(DeleteCollectionResponseSchema)` to create a new message.
 */
export const DeleteCollectionResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 9);

/**
 * Describes the message lat.trails.GetAccountRequest.
 * Use `create(GetAccountRequestSchema)` to create a new message.
 */
export const GetAccountRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 10);

/**
 * Describes the message lat.trails.GetAccountResponse.
 * Use `create(GetAccountResponseSchema)` to create a new message.
 */
export const GetAccountResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 11);

/**
 * Describes the message lat.trails.OwnedCollection.
 * Use `create(OwnedCollectionSchema)` to create a new message.
 */
export const OwnedCollectionSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 12);

/**
 * Describes the message lat.trails.GetAviationWeatherRequest.
 * Use `create(GetAviationWeatherRequestSchema)` to create a new message.
 */
export const GetAviationWeatherRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 13);

/**
 * Describes the message lat.trails.GetAviationWeatherResponse.
 * Use `create(GetAviationWeatherResponseSchema)` to create a new message.
 */
export const GetAviationWeatherResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 14);

/**
 * Describes the message lat.trails.AviationCloud.
 * Use `create(AviationCloudSchema)` to create a new message.
 */
export const AviationCloudSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 15);

/**
 * Describes the message lat.trails.AviationConditions.
 * Use `create(AviationConditionsSchema)` to create a new message.
 */
export const AviationConditionsSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 16);

/**
 * Describes the message lat.trails.Metar.
 * Use `create(MetarSchema)` to create a new message.
 */
export const MetarSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 17);

/**
 * Describes the message lat.trails.Taf.
 * Use `create(TafSchema)` to create a new message.
 */
export const TafSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 18);

/**
 * Describes the message lat.trails.TafPeriod.
 * Use `create(TafPeriodSchema)` to create a new message.
 */
export const TafPeriodSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 19);

/**
 * Describes the message lat.trails.GetCollectionRequest.
 * Use `create(GetCollectionRequestSchema)` to create a new message.
 */
export const GetCollectionRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 20);

/**
 * Describes the message lat.trails.GetCollectionResponse.
 * Use `create(GetCollectionResponseSchema)` to create a new message.
 */
export const GetCollectionResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 21);

/**
 * Describes the message lat.trails.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 22);

/**
 * Describes the message lat.trails.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 23);

/**
 * Describes the message lat.trails.GetInviteRequest.
 * Use `create(GetInviteRequestSchema)` to create a new message.
 */
export const GetInviteRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 24);

/**
 * Describes the message lat.trails.GetInviteResponse.
 * Use `create(GetInviteResponseSchema)` to create a new message.
 */
export const GetInviteResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 25);

/**
 * Describes the message lat.trails.GetOsmTagsRequest.
 * Use `create(GetOsmTagsRequestSchema)` to create a new message.
 */
export const GetOsmTagsRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 26);

/**
 * Describes the message lat.trails.GetOsmTagsResponse.
 * Use `create(GetOsmTagsResponseSchema)` to create a new message.
 */
export const GetOsmTagsResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 27);

/**
 * Describes the message lat.trails.GetSharingRequest.
 * Use `create(GetSharingRequestSchema)` to create a new message.
 */
export const GetSharingRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 28);

/**
 * Describes the message lat.trails.GetSharingResponse.
 * Use `create(GetSharingResponseSchema)` to create a new message.
 */
export const GetSharingResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 29);

/**
 * Describes the message lat.trails.GetTimeZoneRequest.
 * Use `create(GetTimeZoneRequestSchema)` to create a new message.
 */
export const GetTimeZoneRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 30);

/**
 * Describes the message lat.trails.GetTimeZoneResponse.
 * Use `create(GetTimeZoneResponseSchema)` to create a new message.
 */
export const GetTimeZoneResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 31);

/**
 * Describes the message lat.trails.ListCollectionsRequest.
 * Use `create(ListCollectionsRequestSchema)` to create a new message.
 */
export const ListCollectionsRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 32);

/**
 * Describes the message lat.trails.ListCollectionsResponse.
 * Use `create(ListCollectionsResponseSchema)` to create a new message.
 */
export const ListCollectionsResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 33);

/**
 * Describes the message lat.trails.RevokeInviteRequest.
 * Use `create(RevokeInviteRequestSchema)` to create a new message.
 */
export const RevokeInviteRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 34);

/**
 * Describes the message lat.trails.RevokeInviteResponse.
 * Use `create(RevokeInviteResponseSchema)` to create a new message.
 */
export const RevokeInviteResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 35);

/**
 * Describes the message lat.trails.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 36);

/**
 * Describes the message lat.trails.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 37);

/**
 * Describes the message lat.trails.SearchResult.
 * Use `create(SearchResultSchema)` to create a new message.
 */
export const SearchResultSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 38);

/**
 * Describes the message lat.trails.SaveRequest.
 * Use `create(SaveRequestSchema)` to create a new message.
 */
export const SaveRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 39);

/**
 * Describes the message lat.trails.Write.
 * Use `create(WriteSchema)` to create a new message.
 */
export const WriteSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 40);

/**
 * Describes the message lat.trails.PutSchema.
 * Use `create(PutSchemaSchema)` to create a new message.
 */
export const PutSchemaSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 41);

/**
 * Describes the message lat.trails.Delete.
 * Use `create(DeleteSchema)` to create a new message.
 */
export const DeleteSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 42);

/**
 * Describes the message lat.trails.SetAnyoneCanViewRequest.
 * Use `create(SetAnyoneCanViewRequestSchema)` to create a new message.
 */
export const SetAnyoneCanViewRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 43);

/**
 * Describes the message lat.trails.SetAnyoneCanViewResponse.
 * Use `create(SetAnyoneCanViewResponseSchema)` to create a new message.
 */
export const SetAnyoneCanViewResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 44);

/**
 * Describes the message lat.trails.SetGrantRequest.
 * Use `create(SetGrantRequestSchema)` to create a new message.
 */
export const SetGrantRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 45);

/**
 * Describes the message lat.trails.SetGrantResponse.
 * Use `create(SetGrantResponseSchema)` to create a new message.
 */
export const SetGrantResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 46);

/**
 * Describes the message lat.trails.SetViewStateRequest.
 * Use `create(SetViewStateRequestSchema)` to create a new message.
 */
export const SetViewStateRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 47);

/**
 * Describes the message lat.trails.SetViewStateResponse.
 * Use `create(SetViewStateResponseSchema)` to create a new message.
 */
export const SetViewStateResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 48);

/**
 * Describes the message lat.trails.UpdateCollectionRequest.
 * Use `create(UpdateCollectionRequestSchema)` to create a new message.
 */
export const UpdateCollectionRequestSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 49);

/**
 * Describes the message lat.trails.UpdateCollectionResponse.
 * Use `create(UpdateCollectionResponseSchema)` to create a new message.
 */
export const UpdateCollectionResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 50);

/**
 * Describes the message lat.trails.Sharing.
 * Use `create(SharingSchema)` to create a new message.
 */
export const SharingSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 51);

/**
 * Describes the message lat.trails.Grant.
 * Use `create(GrantSchema)` to create a new message.
 */
export const GrantSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 52);

/**
 * Describes the message lat.trails.SaveResponse.
 * Use `create(SaveResponseSchema)` to create a new message.
 */
export const SaveResponseSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 53);

/**
 * Describes the message lat.trails.Collection.
 * Use `create(CollectionSchema)` to create a new message.
 */
export const CollectionSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 54);

/**
 * Describes the message lat.trails.Bound.
 * Use `create(BoundSchema)` to create a new message.
 */
export const BoundSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 55);

/**
 * Describes the message lat.trails.Folder.
 * Use `create(FolderSchema)` to create a new message.
 */
export const FolderSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 56);

/**
 * Describes the message lat.trails.Invite.
 * Use `create(InviteSchema)` to create a new message.
 */
export const InviteSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 57);

/**
 * Describes the message lat.trails.Line.
 * Use `create(LineSchema)` to create a new message.
 */
export const LineSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 58);

/**
 * Describes the message lat.trails.Point.
 * Use `create(PointSchema)` to create a new message.
 */
export const PointSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 59);

/**
 * Describes the message lat.trails.Polygon.
 * Use `create(PolygonSchema)` to create a new message.
 */
export const PolygonSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 60);

/**
 * Describes the message lat.trails.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema = /*@__PURE__*/
  messageDesc(file_trails_lat_proto_data, 61);

/**
 * Describes the enum lat.trails.OsmElementType.
 */
export const OsmElementTypeSchema = /*@__PURE__*/
  enumDesc(file_trails_lat_proto_data, 0);

/**
 * @generated from enum lat.trails.OsmElementType
 */
export const OsmElementType = /*@__PURE__*/
  tsEnum(OsmElementTypeSchema);

/**
 * Describes the enum lat.trails.SearchResultKind.
 */
export const SearchResultKindSchema = /*@__PURE__*/
  enumDesc(file_trails_lat_proto_data, 1);

/**
 * @generated from enum lat.trails.SearchResultKind
 */
export const SearchResultKind = /*@__PURE__*/
  tsEnum(SearchResultKindSchema);

/**
 * Describes the enum lat.trails.FeatureKind.
 */
export const FeatureKindSchema = /*@__PURE__*/
  enumDesc(file_trails_lat_proto_data, 2);

/**
 * @generated from enum lat.trails.FeatureKind
 */
export const FeatureKind = /*@__PURE__*/
  tsEnum(FeatureKindSchema);

/**
 * Describes the enum lat.trails.Role.
 */
export const RoleSchema = /*@__PURE__*/
  enumDesc(file_trails_lat_proto_data, 3);

/**
 * Ordered by how much each allows, because AcceptInvite and the invite page compare them.
 *
 * @generated from enum lat.trails.Role
 */
export const Role = /*@__PURE__*/
  tsEnum(RoleSchema);

/**
 * @generated from service lat.trails.DataService
 */
export const DataService = /*@__PURE__*/
  serviceDesc(file_trails_lat_proto_data, 0);

